import App from './components/emailBindTable.vue'

//import {Type} from 'main.core'

export class EmailBinder
{
    constructor(options = {name: 'EmailBinder'})
    {
        this.name = options.name;

        BX.VueVendorV2.config.productionTip = false;
        BX.VueVendorV2.config.devtools = true; 
        this.vueInstance = BX.Vue.create({
            components: { App },
            el: options.appEl,
            data() { 
                return {
                    messageId: options.data.messageId, 
                    endpointUrl: options.data.endpointUrl,
                    langPack: options.data.langPack,
                    imageUrl: options.data.imageUrl
                } 
            },
            template: `
				<div>
					<App    :message-id="messageId"
							:image-url="imageUrl"
							:endpoint-url="endpointUrl"
							:lang-pack="langPack"
                    />
				</div>
			`,
        });	
    }

    setName(name)
    {
        if (Type.isString(name))
        {
            this.name = name;
        }
    }

    getName()
    {
        return this.name;
    }
}